export const ROLES = Object.freeze({
  ADMIN: 'admin',
  MARKETER: 'marketer',
  CUSTOMER: 'customer',
});

export const ROLE_LIST = Object.values(ROLES);
